import { render, staticRenderFns } from "./DeliveryBlock.vue?vue&type=template&id=9e7c4ecc&"
import script from "./DeliveryBlock.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports